export const WORLD = { w: 2600, h: 1700 };

export const SNACKS = {
  chocolate: { emoji: '🍫', points: 10, color: '#7b4b2a', size: 20 },
  soda:      { emoji: '🥤', points: 15, color: '#e23b3b', size: 21 },
  popcorn:   { emoji: '🍿', points: 20, color: '#f4d35e', size: 21 },
  cookie:    { emoji: '🍪', points: 25, color: '#c68a4b', size: 22 },
  candy:     { emoji: '🍬', points: 30, color: '#ff6fb5', size: 21 },
  donut:     { emoji: '🍩', points: 40, color: '#ff9ecb', size: 23 },
  golden:    { emoji: '⭐', points: 100, color: '#ffd23f', size: 26 },
};

// weighted drop pools; golden is rare
export const MACHINE_TYPES = {
  weak: {
    label: 'Snack Box', maxHealth: 3, color: '#3ddc84', accent: '#1f9e5a',
    breakBonus: 25, noise: { punch: 22, kick: 38, break: 62 },
    pool: ['chocolate', 'chocolate', 'soda', 'soda', 'popcorn'], drop: [2, 3],
  },
  medium: {
    label: 'MegaVend', maxHealth: 6, color: '#4d8bff', accent: '#2b5fc4',
    breakBonus: 60, noise: { punch: 32, kick: 52, break: 86 },
    pool: ['popcorn', 'cookie', 'candy', 'soda', 'cookie'], drop: [3, 5],
  },
  strong: {
    label: 'VaultVend', maxHealth: 10, color: '#b06bff', accent: '#7d3fd6',
    breakBonus: 130, noise: { punch: 42, kick: 66, break: 100 },
    pool: ['candy', 'donut', 'cookie', 'donut', 'golden'], drop: [4, 7],
  },
};

export const POWERUPS = {
  speed:     { emoji: '⚡', name: 'Speed Boost',  color: '#ffd23f', dur: 8 },
  silent:    { emoji: '🥷', name: 'Silent Mode',  color: '#8b9bb4', dur: 10 },
  smash:     { emoji: '💪', name: 'Super Smash',  color: '#ff5a5f', dur: 8 },
  shield:    { emoji: '🛡️', name: 'Guard Shield', color: '#4d8bff', dur: 10 },
  magnet:    { emoji: '🧲', name: 'Snack Magnet', color: '#ff8a3d', dur: 10 },
  double:    { emoji: '💰', name: 'Double Score', color: '#3ddc84', dur: 12 },
  invisible: { emoji: '👻', name: 'Invisible',    color: '#b06bff', dur: 8 },
};

export const SKIN_COLORS = ['#ff5a5f', '#4d8bff', '#3ddc84', '#ffd23f',
                            '#b06bff', '#ff8a3d', '#ff6fb5', '#2ee6d6',
                            '#ffffff', '#111827', '#00e5ff', '#ff2d55',
                            '#a6ff00', '#7d3fd6', '#f4d35e', '#08c47c',
                            '#ff9ecb', '#5a6b8c'];
export const HATS = ['none', 'cap', 'crown', 'beanie', 'party'];

export const MATCH = { countdown: 3, duration: 240 };

// Cosmetic shop catalog. price 0 = owned by default.
export const COSMETICS = {
  hats: [
    { id: 'none', name: 'None', icon: '🚫', price: 0 },
    { id: 'cap', name: 'Cap', icon: '🧢', price: 0 },
    { id: 'beanie', name: 'Beanie', icon: '🧶', price: 0 },
    { id: 'party', name: 'Party', icon: '🎉', price: 100 },
    { id: 'grad', name: 'Grad', icon: '🎓', price: 120 },
    { id: 'top', name: 'Top Hat', icon: '🎩', price: 160 },
    { id: 'crown', name: 'Crown', icon: '👑', price: 200 },
    { id: 'cowboy', name: 'Cowboy', icon: '🤠', price: 220 },
    { id: 'ninja', name: 'Ninja', icon: '🥷', price: 250 },
    { id: 'chef', name: 'Chef', icon: '🧑‍🍳', price: 260 },
    { id: 'devil', name: 'Devil', icon: '😈', price: 320 },
    { id: 'halo', name: 'Halo', icon: '😇', price: 350 },
    { id: 'wizard', name: 'Wizard', icon: '🧙', price: 400 },
    { id: 'alien', name: 'Alien', icon: '👽', price: 500 },
    { id: 'flower', name: 'Flower', icon: '🌸', price: 180 },
    { id: 'star', name: 'Star', icon: '⭐', price: 220 },
    { id: 'skull', name: 'Skull', icon: '💀', price: 300 },
    { id: 'viking', name: 'Viking', icon: '⛑️', price: 320 },
    { id: 'unicorn', name: 'Unicorn', icon: '🦄', price: 420 },
    { id: 'pumpkin', name: 'Pumpkin', icon: '🎃', price: 200 },
    { id: 'gift', name: 'Gift Box', icon: '🎁', price: 180 },
    { id: 'headphones', name: 'Headphones', icon: '🎧', price: 240 },
    { id: 'sprout', name: 'Sprout', icon: '🌱', price: 160 },
    { id: 'firehat', name: 'Flame Head', icon: '🔥', price: 300 },
    { id: 'robot', name: 'Robo Head', icon: '🤖', price: 0, exclusive: true, desc: 'Store-exclusive — from the Starter Heist Pack.' },
  ],
  effects: [
    { id: 'none', name: 'None', icon: '🚫', price: 0 },
    { id: 'sparkle', name: 'Sparkle', icon: '✨', price: 80 },
    { id: 'stars', name: 'Stars', icon: '🌟', price: 120 },
    { id: 'confetti', name: 'Confetti', icon: '🎊', price: 140 },
    { id: 'hearts', name: 'Hearts', icon: '💕', price: 150 },
    { id: 'coins', name: 'Coin Pop', icon: '🪙', price: 200 },
    { id: 'fire', name: 'Fire', icon: '🔥', price: 300 },
    { id: 'lightning', name: 'Lightning', icon: '⚡', price: 380 },
    { id: 'rainbow', name: 'Rainbow', icon: '🌈', price: 450 },
    { id: 'bubbles', name: 'Bubbles', icon: '🫧', price: 120 },
    { id: 'snow', name: 'Snowfall', icon: '❄️', price: 170 },
    { id: 'petals', name: 'Petals', icon: '🌸', price: 210 },
    { id: 'music', name: 'Music Notes', icon: '🎵', price: 240 },
    { id: 'butterfly', name: 'Butterflies', icon: '🦋', price: 220 },
    { id: 'money', name: 'Money Rain', icon: '💵', price: 260 },
    { id: 'magic', name: 'Magic Orbs', icon: '🔮', price: 280 },
    { id: 'skulls', name: 'Spooky', icon: '💀', price: 300 },
  ],
};

// Rotating global chaos events that reshape the match every ~20s.
export const EVENTS = {
  snackrain:  { name: 'SNACK RAIN',   emoji: '🌧️', color: '#4d8bff', tint: 'rgba(77,139,255,0.10)', dur: 16 },
  guardbreak: { name: 'GUARD BREAK',  emoji: '😴', color: '#3ddc84', tint: 'rgba(61,220,132,0.12)', dur: 14 },
  rush:       { name: 'RUSH HOUR',    emoji: '💰', color: '#ffd23f', tint: 'rgba(255,210,63,0.10)', dur: 18 },
  sugar:      { name: 'SUGAR RUSH',   emoji: '⚡', color: '#ff8a3d', tint: 'rgba(255,138,61,0.10)', dur: 14 },
  blackout:   { name: 'BLACKOUT',     emoji: '🌑', color: '#8b9bb4', tint: 'rgba(0,0,0,0.5)',       dur: 13 },
  magnet:     { name: 'MAGNET STORM', emoji: '🧲', color: '#b06bff', tint: 'rgba(176,107,255,0.10)', dur: 14 },
  heist:      { name: 'HEIST ALARM',  emoji: '🚨', color: '#ff2d55', tint: 'rgba(255,45,85,0.12)',  dur: 16 },
  earthquake: { name: 'EARTHQUAKE',   emoji: '🌋', color: '#e2a03b', tint: 'rgba(226,160,59,0.10)', dur: 12 },
};

// Active gadgets — equip one, trigger with Q (or the mobile button).
export const GADGETS = {
  none:      { name: 'No Gadget',      icon: '🚫', price: 0,   cd: 0,  desc: 'No active gadget equipped.' },
  banana:    { name: 'Banana Trap',    icon: '🍌', price: 150, cd: 6,  desc: 'Drop a peel that slips & stuns any guard.' },
  jetpack:   { name: 'Jetpack Dash',   icon: '🚀', price: 250, cd: 8,  desc: 'Rocket a long dash + short speed boost.' },
  smoke:     { name: 'Smoke Bomb',     icon: '💨', price: 200, cd: 12, desc: 'Instantly wipe suspicion + vanish for 4s.' },
  snackbomb: { name: 'Snack Bomb',     icon: '🧨', price: 350, cd: 14, desc: 'Blow up a nearby machine in one hit.' },
  decoy:     { name: 'Decoy Clone',    icon: '🪀', price: 300, cd: 16, desc: 'Spawn a fake you that lures guards away.' },
  disguise:  { name: 'Guard Disguise', icon: '🥸', price: 400, cd: 18, desc: 'Guards ignore you completely for 6s.' },
};

// Companion pets — passive helpers that follow you.
export const PETS = {
  none:   { name: 'No Pet',      icon: '🚫', price: 0,   color: null,      desc: 'No companion.' },
  bird:   { name: 'Snack Bird',  icon: '🐦', price: 200, color: '#4d8bff', desc: 'Auto-grabs snacks near you.' },
  cat:    { name: 'Sneaky Cat',  icon: '🐈', price: 250, color: '#8b9bb4', desc: 'Auto-grabs snacks near you.' },
  dog:    { name: 'Guard Dog',   icon: '🐕', price: 320, color: '#c68a4b', desc: 'Barks to lower nearby guard suspicion.' },
  bot:    { name: 'Magnet Bot',  icon: '🤖', price: 420, color: '#3ddc84', desc: 'Wide-range auto snack collector.' },
  dragon: { name: 'Mini Dragon', icon: '🐉', price: 650, color: '#b06bff', desc: 'Breathes fire to stun nearby guards.' },
};

// Movement trails.
export const TRAILS = {
  none:    { name: 'None',    icon: '🚫', price: 0,   colors: [] },
  bubbles: { name: 'Bubbles', icon: '🫧', price: 80,  colors: ['#8ecbff'] },
  neon:    { name: 'Neon',    icon: '💠', price: 130, colors: ['#2ee6d6'] },
  ocean:   { name: 'Ocean',   icon: '🌊', price: 150, colors: ['#4d8bff', '#2ee6d6'] },
  toxic:   { name: 'Toxic',   icon: '☢️', price: 180, colors: ['#3ddc84', '#a6ff00'] },
  hearts:  { name: 'Lovey',   icon: '💗', price: 190, colors: ['#ff6fb5', '#ff2d55'] },
  ghost:   { name: 'Ghostly', icon: '👻', price: 220, colors: ['#ffffff', '#b06bff'] },
  flames:  { name: 'Flames',  icon: '🔥', price: 260, colors: ['#ff5a3d', '#ffd23f'] },
  gold:    { name: 'Golden',  icon: '🪙', price: 240, colors: ['#ffd23f', '#fff6c0'] },
  shadow:  { name: 'Shadow',  icon: '🌑', price: 260, colors: ['#7d3fd6', '#1a1040'] },
  candy:   { name: 'Candy',   icon: '🍬', price: 220, colors: ['#ff6fb5', '#ffd23f', '#8ecbff'] },
  rainbow: { name: 'Rainbow', icon: '🌈', price: 400, colors: ['#ff5a5f', '#ffd23f', '#3ddc84', '#4d8bff', '#b06bff'] },
  stardust:{ name: 'Stardust',icon: '🌠', price: 0,   colors: ['#ffd23f', '#b06bff', '#ffffff'], exclusive: true, desc: 'Store-exclusive — from the Starter Heist Pack.' },
};

// Glowing auras around your character.
export const AURAS = {
  none:  { name: 'None',       icon: '🚫', price: 0,   color: null },
  gold:  { name: 'Gold Aura',  icon: '🟡', price: 150, color: '#ffd23f' },
  frost: { name: 'Frost Aura', icon: '🔵', price: 150, color: '#4d8bff' },
  toxic: { name: 'Toxic Aura', icon: '🟢', price: 200, color: '#3ddc84' },
  pink:  { name: 'Blush Aura', icon: '💗', price: 220, color: '#ff6fb5' },
  ice:   { name: 'Ice Aura',   icon: '🧊', price: 240, color: '#7fd8ff' },
  fire:  { name: 'Fire Aura',  icon: '🔴', price: 280, color: '#ff5a3d' },
  shadow:{ name: 'Shadow Aura',icon: '⚫', price: 300, color: '#7d3fd6' },
  royal: { name: 'Royal Aura', icon: '🟣', price: 320, color: '#b06bff' },
  lime:  { name: 'Lime Aura',  icon: '🟢', price: 260, color: '#a6ff00' },
  aqua:  { name: 'Aqua Aura',  icon: '🩵', price: 260, color: '#2ee6d6' },
  sunset:{ name: 'Sunset Aura',icon: '🟠', price: 300, color: '#ff8a3d' },
  rainbow:{ name: 'Chroma Aura',icon: '🌈', price: 0,  color: '#ff2a85', exclusive: true, desc: 'Store-exclusive — from the VIP Vault Pass.' },
};

// LEGENDARY animated character skins — premium coin unlocks. Rendered with
// live animation in the engine (twinkling galaxy, molten lava, hue-cycling chroma...).
export const SKINS = {  none:    { name: 'Classic',     icon: '⚪', price: 0,    legendary: false },
  neon:    { name: 'Neon Pulse',  icon: '💡', price: 600,  legendary: true },
  golden:  { name: 'Golden God',  icon: '🏆', price: 900,  legendary: true },
  galaxy:  { name: 'Galaxy',      icon: '🌌', price: 1000, legendary: true },
  lava:    { name: 'Molten Lava', icon: '🌋', price: 1100, legendary: true },
  ghost:   { name: 'Phantom',     icon: '👻', price: 1200, legendary: true },
  diamond: { name: 'Diamond',     icon: '💎', price: 1300, legendary: true },
  aurora:  { name: 'Aurora',      icon: '🌈', price: 1400, legendary: true },
  inferno: { name: 'Inferno',     icon: '🔥', price: 1600, legendary: true },
  frost:   { name: 'Frostbite',   icon: '❄️', price: 1250, legendary: true },
  storm:   { name: 'Thunderstorm',icon: '⛈️', price: 1450, legendary: true },
  rainbow: { name: 'Chroma',      icon: '🌈', price: 1500, legendary: true },
  plasma:  { name: 'Plasma',      icon: '⚡', price: 0, legendary: true, exclusive: true, desc: 'Store-exclusive — from the Legend Bundle.' },
  cyber:   { name: 'Cyber',       icon: '🤖', price: 0, legendary: true, exclusive: true, desc: 'Store-exclusive — from the VIP Vault Pass.' },
  void:    { name: 'Void',        icon: '🕳️', price: 0, legendary: true, exclusive: true, desc: 'Store-exclusive — from the VIP Vault Pass.' },
  prism:   { name: 'Prism',       icon: '🔷', price: 0, legendary: true, exclusive: true, desc: 'Store-exclusive — from the Neon Bundle.' },
  nebula:  { name: 'Nebula',      icon: '🌠', price: 0, legendary: true, exclusive: true, desc: 'Store-exclusive — from the Ultimate Pack.' },
};

// Each legendary skin emits its own matching motion trail.
export const SKIN_TRAILS = {
  neon: ['#2ee6d6'],
  golden: ['#ffd23f', '#fff6c0'],
  galaxy: ['#b06bff', '#ffffff'],
  lava: ['#ff5a3d', '#ffd23f'],
  ghost: ['#e6ebff', '#b06bff'],
  diamond: ['#7fd8ff', '#ffffff'],
  aurora: ['#3ddc84', '#4d8bff', '#b06bff'],
  inferno: ['#ff2d55', '#ff8a3d', '#ffd23f'],
  frost: ['#7fd8ff', '#ffffff', '#4d8bff'],
  storm: ['#ffd23f', '#8ec0ff', '#ffffff'],
  rainbow: ['#ff5a5f', '#ffd23f', '#3ddc84', '#4d8bff', '#b06bff'],
  plasma: ['#ff2a85', '#4d8bff', '#ffffff'],
  cyber: ['#2ee6d6', '#a6ff00'],
  void: ['#7d3fd6', '#1a1040', '#ff2a85'],
  prism: ['#ff5a5f', '#4d8bff', '#3ddc84', '#ffffff'],
  nebula: ['#b06bff', '#ff2a85', '#4d8bff', '#ffffff'],
};
